module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cf-page",
    class: {
      'is-lock': !_vm.canEdit,
      'is-embed': _vm.embedded
    }
  }, [_c('div', {
    staticClass: "cf-app"
  }, [(_vm.loaded && _vm.blockTip) ? _c('div', {
    staticClass: "rater"
  }, [_vm._v(_vm._s(_vm.blockTip))]) : (_vm.loaded && !_vm.canEdit) ? _c('div', {
    staticClass: "rater"
  }, [_vm._v("评分人：" + _vm._s(_vm.raterName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "rate"
  }, [_c('div', {
    staticClass: "q"
  }, [_vm._v("本节课整体表现，打几星？")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("1 星最低，5 星最高；打完星自动匹配该星级对应的课堂表现")]), _vm._v(" "), _c('div', {
    staticClass: "bigstars"
  }, _vm._l((5), function(n) {
    return _c('span', {
      key: n,
      staticClass: "s",
      class: {
        on: _vm.star >= n
      },
      on: {
        "click": function($event) {
          return _vm.setStar(n)
        }
      }
    }, [_vm._v("★")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "rate-read"
  }, [(!_vm.star) ? _c('span', {
    staticClass: "hint"
  }, [_vm._v("点击星星打分")]) : [_c('span', {
    staticClass: "emo"
  }, [_vm._v(_vm._s(_vm.face))]), _vm._v(" "), _c('span', [_c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.rateStarText))]), _vm._v(" "), _c('span', {
    staticClass: "hint"
  }, [_vm._v("　" + _vm._s(_vm.star) + " 星 · " + _vm._s(_vm.faceTxt))])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "sug",
    class: {
      show: _vm.star > 0
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.recList), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "tag",
      class: {
        sel: _vm.isPicked(o.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v(_vm._s(o.text))]), _vm._v(" "), _c('div', {
      staticClass: "d"
    }, [_vm._v(_vm._s(o.dim))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "sugbtns"
  }, [_c('button', {
    staticClass: "mini strong",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_vm._v("换一换")]), _vm._v(" "), _c('button', {
    staticClass: "mini",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleLib
    }
  }, [_vm._v(_vm._s(_vm.libBtnText))])]), _vm._v(" "), _c('div', {
    staticClass: "lib",
    class: {
      show: _vm.libOpen
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.libKw),
      expression: "libKw"
    }],
    staticClass: "search",
    attrs: {
      "placeholder": "搜索关键词，如：纠音、口音、开口、迟到"
    },
    domProps: {
      "value": (_vm.libKw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.libKw = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.star) ? _c('div', [(_vm.libList.length) ? _c('div', {
    staticClass: "grp"
  }, [_c('h4', [_c('span', {
    staticClass: "n"
  }, [_vm._v(_vm._s(_vm.star) + "星")]), _vm._v(" " + _vm._s(_vm.faceTxt) + "　" + _vm._s(_vm.libList.length) + " 项" + _vm._s(_vm.libSuffix))]), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.libList), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "tag",
      class: {
        sel: _vm.isPicked(o.id)
      },
      on: {
        "click": function($event) {
          return _vm.toggle(o.id)
        }
      }
    }, [_c('div', {
      staticClass: "t"
    }, [_vm._v(_vm._s(o.text))]), _vm._v(" "), _c('div', {
      staticClass: "d"
    }, [_vm._v(_vm._s(o.dim))])])
  }), 0)]) : _c('div', {
    staticClass: "lib-empty"
  }, [_vm._v("该星级下没有匹配的选项")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "picked",
    class: {
      show: _vm.pickedIds.length > 0
    }
  }, [_c('div', {
    staticClass: "hd"
  }, [_vm._v("已选表现 "), _c('span', [_vm._v(_vm._s(_vm.pickCountText))])]), _vm._v(" "), _c('div', {
    staticClass: "chips"
  }, _vm._l((_vm.pickedItems), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "chip",
      on: {
        "click": function($event) {
          return _vm.removePicked(o.id)
        }
      }
    }, [_vm._v(_vm._s(o.text) + " "), _c('i', [_vm._v("· " + _vm._s(o.dim) + " · " + _vm._s(o.star) + "星")])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.conflictText),
      expression: "conflictText"
    }],
    staticClass: "conflict"
  }, [_vm._v(_vm._s(_vm.conflictText))])]), _vm._v(" "), _c('div', {
    staticClass: "redcard",
    class: {
      on: _vm.redCodes.length > 0
    }
  }, [_c('div', {
    staticClass: "rt"
  }, [_vm._v("红线库（一票否决）")]), _vm._v(" "), _c('div', {
    staticClass: "rd"
  }, [_vm._v("勾选任一红线项 → 本次直接判 1 星；外教可在 7 日内申请复听重评")]), _vm._v(" "), _vm._l((_vm.redList), function(item) {
    return _c('div', {
      key: item.code,
      staticClass: "ritem",
      class: {
        sel: _vm.isRed(item.code)
      },
      on: {
        "click": function($event) {
          return _vm.toggleRed(item.code)
        }
      }
    }, [_c('span', {
      staticClass: "ck"
    }), _vm._v(" "), _c('span', {
      staticClass: "rl-t"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('span', {
      staticClass: "rl-d"
    }, [_vm._v(_vm._s(item.desc))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "summary"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "sum-label"
  }, [_vm._v("综合评分")]), _vm._v(" "), _c('div', {
    staticClass: "score"
  }, [_c('span', [_vm._v(_vm._s(_vm.scoreText))]), _c('small', [_vm._v(" / 5.00")])])]), _vm._v(" "), _c('div', {
    staticClass: "sum-right"
  }, [_c('div', {
    staticClass: "big"
  }, [_vm._v(_vm._s(_vm.summaryStars))]), _vm._v(" "), _c('div', {
    staticClass: "grade"
  }, [_vm._v(_vm._s(_vm.gradeText))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.adviceText),
      expression: "adviceText"
    }],
    staticClass: "advice"
  }, [_vm._v(_vm._s(_vm.adviceText))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.redWarn),
      expression: "redWarn"
    }],
    staticClass: "warn"
  }, [_vm._v(_vm._s(_vm.redWarn))])]), _vm._v(" "), _c('div', {
    staticClass: "card note"
  }, [_c('h2', [_vm._v("补充说明（可选）")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.note),
      expression: "note"
    }],
    attrs: {
      "maxlength": "500",
      "readonly": !_vm.canEdit,
      "placeholder": "我还有话说…（典型问题、亮点行为、建议复查时间）"
    },
    domProps: {
      "value": (_vm.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cnt"
  }, [_c('span', [_vm._v(_vm._s(_vm.note.length))]), _vm._v("/500")])]), _vm._v(" "), (_vm.canEdit) ? _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cap"
  }, [_c('b', [_vm._v("该星级对应的课堂表现")]), _vm._v("（勾选符合的项，可多选）：")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a03f8c9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lesson/ClassFeedback.vue
// module id = 1852
// module chunks = 8